import { render, staticRenderFns } from "./applayout.vue?vue&type=template&id=9b59f44e&lang=pug"
import script from "./applayout.vue?vue&type=script&lang=js"
export * from "./applayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports